/**
 * ModernFusion — design tokens.
 *
 * Urban Indian blend: sage green, dusty rose, champagne gold.
 */

import type { CSSProperties } from 'react';

export interface ModernTheme {
  sage: string;
  sageDark: string;
  rose: string;
  roseSoft: string;
  champagne: string;
  champagneSoft: string;
  cream: string;
  ink: string;
  muted: string;
  border: string;
}

export const modernTheme: ModernTheme = {
  sage: '#87a878',
  sageDark: '#5a7a52',
  rose: '#c9a9a6',
  roseSoft: '#e8d5d3',
  champagne: '#d4af37',
  champagneSoft: '#f0e6c3',
  cream: '#faf9f6',
  ink: '#2c2c2c',
  muted: '#6b6b6b',
  border: 'rgba(135, 168, 120, 0.15)',
};

export const MODERN_EASE = [0.22, 1, 0.36, 1] as const;

export function themeCssVars(theme: ModernTheme): CSSProperties {
  return {
    '--modern-sage': theme.sage,
    '--modern-sage-dark': theme.sageDark,
    '--modern-rose': theme.rose,
    '--modern-rose-soft': theme.roseSoft,
    '--modern-champagne': theme.champagne,
    '--modern-champagne-soft': theme.champagneSoft,
    '--modern-cream': theme.cream,
    '--modern-ink': theme.ink,
    '--modern-muted': theme.muted,
    '--modern-border': theme.border,
  } as CSSProperties;
}
